export default __webpack_public_path__ + "static/media/34.51441ef4.jpg";